import { DEFAULT_LOCALE, LOCAL_STORAGE_KEY_LOCALE } from "@/v1/config/constants";
import guid from "@/v1/utils/guid";

import { CHANGE_LOCALE, SET_BREADCRUMB } from "./types";

const availableLocales = ["en", "es"];

const initialState = {
  breadcrumbs: [],
};

const localStorageValue = localStorage.getItem(LOCAL_STORAGE_KEY_LOCALE);
if (localStorageValue) {
  initialState.locale = localStorageValue;
} else {
  initialState.locale = availableLocales.some(locale => navigator.language.includes(locale))
    ? navigator.language
    : DEFAULT_LOCALE;
}

export default (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
  case CHANGE_LOCALE:
    localStorage.setItem(LOCAL_STORAGE_KEY_LOCALE, payload.locale);
    return Object.assign({}, state, { locale: payload.locale });
  case SET_BREADCRUMB:
    return Object.assign({}, state, {
      breadcrumbs: payload.breadcrumbs.map(crumb => ({ ...crumb, id: guid() })),
    });
  default:
    return state;
  }
};
